import { useEffect, useRef, useState } from "react";
import { matchPresentationPhase, presentationStart } from "./matchPresentation";

// The callback only re-reads the public page. The clock never saves match data.
export default function useMatchPageRefresh(match, onRefresh, busy, enabled = true) {
  const [, tick] = useState(0);
  const latest = useRef({ onRefresh, busy });
  latest.current = { onRefresh, busy };
  const phase = matchPresentationPhase(match);
  const active = enabled && Boolean(match) && ["scheduled", "in_progress"].includes(phase);
  const start = presentationStart(match);
  useEffect(() => {
    if (!active) return undefined;
    let lastRead = -Infinity;
    const refresh = () => {
      if (document.visibilityState === "hidden") return;
      tick(value => value + 1); // Transition even if the network is slow/offline.
      if (!latest.current.busy && Date.now() - lastRead >= 1000) {
        lastRead = Date.now();
        latest.current.onRefresh?.();
      }
    };
    const interval = window.setInterval(refresh, 30000);
    const delay = start === null ? 0 : start - Date.now();
    const boundary = delay > 0 && delay <= 2147483647 ? window.setTimeout(refresh, delay) : null;
    document.addEventListener("visibilitychange", refresh);
    window.addEventListener("focus", refresh);
    return () => {
      window.clearInterval(interval);
      if (boundary !== null) window.clearTimeout(boundary);
      document.removeEventListener("visibilitychange", refresh);
      window.removeEventListener("focus", refresh);
    };
  }, [active, match?.matchId, start]);
}
